import { hydrate, onDOMReady } from '../../render';
import component from './component';

onDOMReady(() => hydrate(component, 'footer'));
